import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import queryString from 'qs'

import Terms from '../legal/Terms'
import { renderTextField, Submit } from '../form'

import { InputGroup, Center, AuthToken, Column } from './shared'
import { validRequired, validPassword } from '../form/validate'

const IntroText = styled.div`
  font-size: 21px;
  text-align: center;
  color: ${({ theme }) => theme.colors.textGreyDarker};
`

class SetPassword extends React.Component {
  render() {
    const { location, handleSubmit, pristine } = this.props
    const { invitation_token, invitation_type } = queryString.parse(
      location.search,
      {
        ignoreQueryPrefix: true,
      }
    )
    const isStorytellerInvitation = invitation_type === 'storyteller'

    return (
      <form
        className="qa-set-password"
        action="/users/invitation"
        method="post"
        ref={(ref) => (this.form = ref)} // eslint-disable-line
        onSubmit={handleSubmit(() => {
          this.form.submit()
        })}
      >
        <AuthToken />
        <input type="hidden" name="_method" value="put" />
        <input
          type="hidden"
          value={invitation_token}
          name="user[invitation_token]"
        />

        <div className="container">
          <div className="row">
            <Column className="col-xs-12 col-md-6 col-md-push-3">
              <IntroText className="mb-5">
                First, we need you to set a password to keep your new Riparide
                account secure.
              </IntroText>

              {!isStorytellerInvitation && (
                <IntroText className="mb-5">
                  Don’t worry though, this doesn’t commit you to listing with
                  us. You’ll have the opportunity to review all the details
                  before you decide to publish.
                </IntroText>
              )}

              <Field
                label="New password"
                name="user[password]"
                type="password"
                component={renderTextField}
                validate={[validRequired, validPassword]}
                lessMargin
              />

              <Field
                label="Confirm new password"
                name="user[password_confirmation]"
                type="password"
                component={renderTextField}
                validate={[validRequired, validPassword]}
                lessMargin
              />

              <InputGroup>
                <Terms />
              </InputGroup>

              <InputGroup>
                <Center>
                  <Submit name="commit" disabled={pristine}>
                    Continue
                  </Submit>
                </Center>
              </InputGroup>
            </Column>
          </div>
        </div>
      </form>
    )
  }
}

const SetPasswordForm = reduxForm({
  form: 'SetPassword',
})(SetPassword)

export default connect(({ auth }) => ({
  currentUser: auth.currentUser,
}))(SetPasswordForm)
